export enum TransitionType {
  /** 节点更新后重绘处理 */
  REPAINT
}